import React, { Component } from 'react';
import Immutable from 'immutable';
import { toastr } from 'react-redux-toastr';
import { change, reset } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NEW_ITINERARY_EXTRAORDINARY_MOVEMENT_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { postKidsOnItinerary } from '../../../../actions/itinerary';
import KidsOnItineraryForm from './KidsOnItineraryForm';
import Content from '../../../layout/Content';
import { getSubstring } from '../../../../utils/string';

export class KidsOnItinerary extends Component {

  onSubmit = (formValues) => {
    const itineraryId = formValues.itineraryId || '';

    const newFormValues = {
      itineraryId: getSubstring(formValues.itineraryId),
      kidCustomerId: formValues.kidCustomerId.value,
      parentCustomerId: formValues.parentCustomerId ? formValues.parentCustomerId.value : null,
      relationship: formValues.relationship.value,
      comments: formValues.comments || null,
      kidWithSeatAssigned: formValues.kidHasSeat || false,
      notarizedPermit: formValues.notarizedPermit || null,

    };

    const isDuplicated = this.validateIfFormValuesIsDuplicated(newFormValues);
    if (isDuplicated) {
      toastr.error('Error', 'Ya existe un menor de edad asignado a este itinerario con el mismo padre o apoderado');
      return;
    }

    this.props.dispatchPostKidsOnItinerary(newFormValues, true, () => this.clearFormValues(itineraryId));

  };

  clearFormValues = (itineraryId) => {
    this.props.dispatchReset('KidsOnItineraryForm');
    this.props.dispatchChange('KidsOnItineraryForm', 'itineraryId', itineraryId);
  }

  validateIfFormValuesIsDuplicated = (formValues) => {
    const { kidsOnItineraryList } = this.props;
    const data = kidsOnItineraryList ? kidsOnItineraryList.get('content') || [] : [];

    return data.some((kidOnItinerary) => {
      const isSameKid = kidOnItinerary.kidCustomerId === formValues.kidCustomerId;
      const isSameCustomer = kidOnItinerary.parentCustomerId === formValues.parentCustomerId;
      return isSameKid && isSameCustomer;
    });
  };

  render() {
    return (
      <Content
        breadcrumbs={this.props.breadcrumbs}
        title="Asignar Menor de Edad a Itinerario"
        subtitle="Puede agregar o quitar uno o varios menores de edad a un itinerario para luego ser mostrado(s) en el manifiesto"
        content={<KidsOnItineraryForm onSubmit={this.onSubmit} />}
      />
    );
  }
}

const mapStateToProps = ({ ItineraryUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Asignar Menor de Edad a Itinerario',
      href: NEW_ITINERARY_EXTRAORDINARY_MOVEMENT_PATH,
    },
  ],
  kidsOnItineraryList: ItineraryUnit.KidsOnItinerary.getIn([
    'current',
    'content',
  ]),
});

const mapDispatchToProps = {
  dispatchPostKidsOnItinerary: postKidsOnItinerary,
  dispatchChange: change,
  dispatchReset: reset,
};

KidsOnItinerary.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostKidsOnItinerary: PropTypes.func.isRequired,
  kidsOnItineraryList: PropTypes.instanceOf(Immutable.Map),
  dispatchChange: PropTypes.func.isRequired,
  dispatchReset: PropTypes.func.isRequired,
};

KidsOnItinerary.defaultProps = {
  kidsOnItineraryList: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(KidsOnItinerary);
